import * as React from 'react';
import { cn } from '../../../utils';

type ListToolbarProps = {
  /** Segment tabs rendered above the toolbar card. */
  tabs?: React.ReactNode;
  /** The search box (usually `SearchInput`). */
  search?: React.ReactNode;
  /** Filter button, toggles, export menus… sit next to the search. */
  actions?: React.ReactNode;
  /** The one primary button (usually "Add"), pinned to the right. */
  primaryAction?: React.ReactNode;
  /** `ActiveFilterChips`; shown on a second row when present. */
  chips?: React.ReactNode;
  className?: string;
};

/**
 * Layout for the top of a list page: tabs, then one card with
 * [search][actions]              [primary]
 * [chips…]
 * Everything wraps on narrow screens.
 */
export function ListToolbar({ tabs, search, actions, primaryAction, chips, className }: ListToolbarProps) {
  return (
    <div className={cn('space-y-3', className)}>
      {tabs}
      <div className="rounded-lg border border-border bg-card p-3 sm:p-4">
        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          {search}
          {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
          {primaryAction ? <div className="ml-auto flex items-center gap-2">{primaryAction}</div> : null}
        </div>
        {chips ? <div className="mt-3">{chips}</div> : null}
      </div>
    </div>
  );
}
